import { render, staticRenderFns } from "./UsersStandalone.vue?vue&type=template&id=5a542224&scoped=true"
import script from "./UsersStandalone.vue?vue&type=script&lang=js"
export * from "./UsersStandalone.vue?vue&type=script&lang=js"
import style0 from "./UsersStandalone.vue?vue&type=style&index=0&id=5a542224&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a542224",
  null
  
)

export default component.exports